// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__39NOZ","imageUploader":"EGiftCard_imageUploader__1fQS2"};